import determineDecorationImageURL from "./determine_decoration_image_URL";

export const checkForHolidayDecorations = (currentGameDate, conditionsTable) => {
    const dateArr = currentGameDate.split('-');
    const gameMonth = dateArr[1];
    let holidayDecoration = false;
    let holidayObj = {};
    if (gameMonth === "12"){
        holidayObj = determineDecorationImageURL(conditionsTable);
        if (holidayObj.decorationFound === true){
            holidayDecoration = true;
        }
    }

    const returnObj = {holidayDecoration: holidayDecoration, holidayObj: holidayObj};
    return returnObj;
}
export default checkForHolidayDecorations;